import { Dispatch } from 'redux';
import { IUserAttr } from '../actions/session';
import * as Actions from '../actions/skill';
import { ICareerMapCell, ICareerMapField } from '../actions/skill';
import AbstractScenario from './AbstractScenario';

export interface ISearchFieldParam {
	userAttr: IUserAttr;
	cmId: string;
}

export interface ISearchCellParam {
	userAttr: IUserAttr;
	cmId: string;
	fieldID: string;
	fieldLevel: string;
	userId: string;
}
export default class ProcessStatusScenarioFactory {
	/**
	 * 分野の取得
	 * @param dispatch ディスパッチャ
	 * @param token Web APIトークン
	 */
	public static FetchCareerMapField(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<ISearchFieldParam> {
			protected process(arg: ISearchFieldParam) {
				// データ取得
				const param = {
					accessType: '10',
					cmId: arg.cmId,
					lang: arg.userAttr.lang,
				};
				return this.read(
					'per_skill_CareerMapFieldListModel',
					param
				).then(data => {
					const careerMapName: string = data.careerMapName;
					const fieldlevelOne: ICareerMapField[] = data.fieldlevelOne;
					const fieldlevelTwo: ICareerMapField[] = data.fieldlevelTwo;
					const fieldlevelThree: ICareerMapField[] =
						data.fieldlevelThree;
					this.dispatch(
						Actions.setCareerMapFieldList({
							careerMapName,
							fieldlevelOne,
							fieldlevelThree,
							fieldlevelTwo,
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * レベル取得の取得
	 * @param dispatch ディスパッチャ
	 * @param token Web APIトークン
	 */
	public static FetchCarerrMapCell(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<ISearchCellParam> {
			protected process(arg: ISearchCellParam) {
				// データ取得
				const param = {
					accessType: '10',
					cmId: arg.cmId,
					fieldID: arg.fieldID,
					fieldLevel: arg.fieldLevel,
					lang: arg.userAttr.lang,
					userId: arg.userId,
				};
				return this.read(
					'per_skill_CareerMapCellListModel',
					param
				).then(data => {
					const careerMapCellList: ICareerMapCell[] = data;
					this.dispatch(
						Actions.setCareerMapCellData({ careerMapCellList })
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}
}



// WEBPACK FOOTER //
// ./src/scenario/ProcessStatusScenarioFactory.ts